import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { MepEmissionTargets } from "../../tabs/mep-emission-targets/mep-emission-targets";
import { MepEmissionTypesConfig } from "../../tabs/mep-emission-targets/partials/mep-emission-types-config/mep-emission-types-config";


@autoinject
export class AddEmissionTypeDialog {

    inActiveTargets: MepEmissionTypesConfig[] = null;
    model: MepEmissionTargets;

    constructor(private dialogClientService: DialogClientService) { 

    }

    activate(model: MepEmissionTargets){
        this.model = model;
        this.inActiveTargets = model.inActiveTargets;
    }

    close() {
        this.model.activateConfigItems();
        this.dialogClientService.hide();
    }
}